import { Button, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { Add, Search } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import { pagingHealthCareService } from "app/services/PublicService";
import { pagingServiceGroup } from "app/services/ServiceGroupService";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
const SearchRegisterService = ({ handleOpenCreateOrEditPopup }) => {
  const { values } = useFormikContext();
  return (
    <>
      <Grid container spacing={1} className="cards-body">
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Tìm kiếm"
            name="keyword"
            placeholder={"Nhập tên/Mã dịch vụ"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
            <GlobitsMultiDatePicker 
              label="Ngày đăng ký từ ngày - đến ngày" 
              name="fromDate"
              range
              rangeHover
              fromField="fromDate"
              toField="toDate"
              // format={"DD/MM/YYYY"}
            />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            api={pagingServiceGroup}
            name={"groupId"}
            label="Nhóm dịch vụ"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            api={pagingHealthCareService}
            label={"Dịch vụ"}
            name={"healthCareSvId"}
            searchObject={{ 
              serviceGroupId: values?.groupId?.id,
              isUsing: true 
            }}
            renderOption={(item) => (
              <div
                className="flex-wrap gap-1 w-100"
                style={{ borderBottom: "1px solid #ccc" }}
              >
                <b>{item?.name || ""}</b>({item?.code || ""})
              </div>
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} className="flex flex-end gap-2">
          <Button className="btn-primary" type="submit">
            <Search />
            Tìm kiếm
          </Button>
          {/* <CommonButton
            className="btn-add"
            onClick={() => {
              handleOpenCreateOrEditPopup();
            }}
          >
            <Add />
          </CommonButton> */}
        </Grid>
      </Grid>
    </>
  );
};

export default memo(observer(SearchRegisterService));
